export default function Error404({ t, copy }) {
    return (
        <div style={{ padding: 20, textAlign: "center" }}>
            <h1 style={{ fontSize: 48, marginBottom: 20 }}>404</h1>
            <p style={{ fontSize: 18, color: t.dim }}>
                {copy.error404}
            </p>
        </div>
    );
}
